import React, { Component, Fragment } from 'react';
import authService from '../../api-authorization/AuthorizeService'
import { Button, Form, FormGroup, Label, Input, FormText, Badge, CustomInput } from 'reactstrap';

import PerkDetailsHelp from './PerkDetailsHelp';
import { MContext } from '../../common/HelpProvider'

import './PerkDetailsForm.css';

export class PerkDetailsForm extends Component {
    static displayName = PerkDetailsForm.name;

    constructor(props) {
        super(props);
        this.state = {
            designerId: props.designerId,
            perkId: props.perkId,
            data: props.data,
            loading: false,
            error: null
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.setError = this.setError.bind(this);
    }

    componentWillReceiveProps(props) {
        //this.setState({ data: props.data })
    }

    setError(error) {
        this.props.setError(error);
        this.setState({ loading: false });
    }

    handleInputChange(event) {
        const target = event.target;

        let value;
        switch (target.type) {
            case 'checkbox':
                value = target.checked;
                break;
            case 'file':
                value = target.files[0];
                break;
            case 'radio':
                value = parseInt(target.value);
                break;
            case 'number':
                value = parseFloat(target.value);
                break;
            default:
                value = target.value;
                break;
        }
        const name = target.name;

        this.setState(prevState => ({
            data: {
                ...prevState.data,
                [name]: value
            }
        }));
    }

    handleSingleLineTextArea = (e) => {
        if (e.keyCode === 13) {
            e.preventDefault();
            return false;
        }
    }

    render() {
        const { data, loading } = this.state;
        return (
            <MContext.Consumer>
                {(context) => (
                    <Form onSubmit={this.handleSubmit}>
                        <div className="bg-white rounded box-shadow p-4 mb-4 mb-lg-0">
                            <FormGroup>
                                <Label for="Title">Perk title <span className="icon icon-help" role="img" aria-label="Help"></span></Label>
                                <Input type="input" name="title" id="Title"
                                    placeholder="Perk title"
                                    value={data.title}
                                    maxLength="100" required
                                    className="bg-white"
                                    onChange={this.handleInputChange}
                                    onFocus={() => context.setHelp(PerkDetailsHelp.FocusType.TITLE)}
                                    onBlur={() => context.setHelp(PerkDetailsHelp.FocusType.NONE)}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label for="AvailableToAllProducts">Availability</Label>
                                <div>
                                    <CustomInput type="switch" id="AvailableToAllProducts" name="availableToAllProducts" label="Make this perk available to all products"
                                        defaultChecked={data.availableToAllProducts}
                                        onClick={this.handleInputChange}
                                    />
                                </div>
                            </FormGroup>
                            <FormGroup>
                                <Label for="ClaimContent">Claim Content <span className="icon icon-help" role="img" aria-label="Help"></span></Label>
                                <Input type="textarea" name="claimContent" id="ClaimContent"
                                    value={data.claimContent || ""}
                                    maxLength="8000" required
                                    onChange={this.handleInputChange}
                                    onFocus={() => context.setHelp(PerkDetailsHelp.FocusType.TAGLINE)}
                                    onBlur={() => context.setHelp(PerkDetailsHelp.FocusType.NONE)}
                                />
                            </FormGroup>
                            <FormGroup>
                                <Label for="MaxTotalPerkClaim">Max Total Claim Allowed<span className="icon icon-help" role="img" aria-label="Help"></span></Label>
                                <Input type="number" name="maxTotalPerkClaim" id="MaxTotalPerkClaim"
                                    value={data.maxTotalPerkClaim || ""}
                                    maxLength="6"
                                    onChange={this.handleInputChange}
                                    style={{ maxWidth: '140px' }}
                                    className="simpletxt"
                                    onFocus={() => context.setHelp(PerkDetailsHelp.FocusType.PRICING)}
                                    onBlur={() => context.setHelp(PerkDetailsHelp.FocusType.NONE)}
                                />
                                <FormText color="muted">
                                    Optional: leaving this field empty will not restrict the number of claims allowed for this perk.
                                </FormText>
                            </FormGroup>

                            <div className="p-4 mb-5 formbox-savebtn">
                                <div className="row">
                                    <div className="col-7"></div>
                                    <div className="col-5 text-right"><Button color="dark" size="sm" disabled={loading}>{!loading ? 'Save changes' : 'Loading..'}</Button></div>
                                </div>
                            </div>
                        </div>
                    </Form>
                )}
            </MContext.Consumer>
        );
    }

    async handleSubmit(event) {
        event.preventDefault();

        this.setState({ loading: true });

        console.log('submitting..');
        console.log(this.state);

        const token = await authService.getAccessToken();
        if (!token) {
            this.setError(`Could not retrieve authentication`);
            return;
        }

        const reqHeader = {
            'Content-Type': 'application/json',
            'Cache-Control': 'no-cache',
            'Authorization': `Bearer ${token}`
        };

        const { data } = this.state;

        const response = await fetch(`/api/brand/${this.state.designerId}/perks/details/${this.state.perkId}/edit`, {
            method: 'post',
            headers: reqHeader,
            body: JSON.stringify({
                title: data.title,
                availableToAllProducts: data.availableToAllProducts,
                claimContent: data.claimContent,
                maxTotalPerkClaim: data.maxTotalPerkClaim
            })
        });


        try {
            const newDta = await response.json();

            if (newDta && newDta.result) {
                //added
                console.log('Perk submitted');
                console.log(newDta);

                //this.setState({ data: newDta.product, loading: false });
                this.setState({ loading: false });

                //this.props.scrollPageToTop();
                this.props.updateData(function () {
                    //update button state
                });
            } else {
                this.setError(`Error`);
            }
        } catch (e) {
            this.setError(`Error`);
            console.log(e);
        }
    }
}
